import { Component, Injector } from '@angular/core';
import { AppComponentBase } from '@shared/app-component-base';

@Component({
  selector: 'aceita-termos-form-cadastro-paciente',
  templateUrl: './aceita-termos-form-cadastro-paciente.component.html',
  styleUrls: ['./aceita-termos-form-cadastro-paciente.component.scss']
})
export class AceitaTermosFormCadastroPacienteComponent extends AppComponentBase {
  protected aceitouTermos: boolean = false;

  constructor(injector: Injector) { super(injector) }


  public isValided(): boolean {
    return this.showErros([
      { condition: !this.aceitouTermos, message: "Você precisa aceitar os Termos de Uso e a Política de Privacidade." },
    ]);
  }

  private showErros(validations) {
    for (const validation of validations) {
      if (validation.condition) {
        this.notify.warn(this.l(validation.message));
        return false;
      }
    }

    return true;
  }
}
